export const state = {
  isLoading: false,
  loadingCount: 0
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/common/state.js